
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Ref, Vue} from "vue-property-decorator";
import SignalSource from "@/components/signalSoure/signal-source.vue";
import Opt from "@/ts/Opt";
import {IconEnum, RTCUserMark, SizeEnum, UserOnlineStatus, UserType} from "@/ts/Enum";
import LessonsData from "@/components/lessonsData/lessons-data.vue";
import ToolButtonClass from "@/ts/ToolButton";
import ToolButton from "@/views/teacherClassRoom/tool-button.vue";
import RTCClient from "@/rtc/RTCClient";
import {MessageBase} from "@/ts/Announcement";
import MqttClient from "@/mqtt/mqttClient";
import Chat from "@/components/messageInteraction/chat.vue";
import util from "@/utils/util";
import {
  class_activity_announcement_topic_prefix,
  class_activity_chat_message_topic_prefix,
  class_activity_forced_kick_topic_prefix,
  class_activity_status_topic_prefix,
  free_activity_status_topic_prefix,
  teacher_online_status_topic_prefix
} from '@/ts/Constant'
import LessonsDataDialog from "@/components/lessonsData/lessons-data-dialog.vue";
import {MessageBox} from "element-ui";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({
  components: {
    LessonsDataDialog,
    Chat,
    LessonsData,
    SignalSource,
    ToolButton,
  },
})
export default class StudentClassroom extends Vue {
  // 用户在rtc直播间的认证信息
  rtcAuthInfo = null
  // 当前用户是否扔在直播间，默认为true。 当用户离开直播间时置位false
  inClassroom = true
  // 用户的默认展示用名
  displayName = ''
  userType = ''
  // 用户的I
  userId = ''
  // 当前课堂的课堂ID码
  classIdCode = ''
  // 当前可以播放的画面数量
  pictureCount = 1

  gardenId = ''
  loading = true
  // 活动加入类型，也就是如何进入到当前活动的。默认为 class。class：通过班级正在进行的马良笔双师课堂活动点击进入，freeJoin：通过课堂ID自由加入
  joinType = 'class'
  size: SizeEnum = SizeEnum.small
  toolSize: SizeEnum = SizeEnum.mini
  lessonsSize: SizeEnum = SizeEnum.small
  leftHeadInfo = ''
  rightHeadTitle = "留言互动区:"
  videoHeadTitle = "信号源"
  videoSourceOptionList = [
    new Opt(1, "本机摄像头", null, "lwicon-shexiangtou1"),
    // new Opt(2, "电脑屏幕", null, "lwicon-pingmu"),
    // new Opt(3, '画中画', null, 'iconhuazhonghua')
  ]
  // 摄像头和麦克风设备开关列表。麦克风和摄像头默认是开启的状态，页面初始化时也会默认去推送摄像头和麦克风的流。
  defaultLocalDeviceList = [
    // new ToolButtonClass(1, "麦克风开关", "microphone-control-open.svg", "microphone-control-close.svg", '开启麦克风', '关闭麦克风', true),
    new ToolButtonClass(2, "音视频开关", "camera-control-open.svg", "camera-control-close.svg", '开启音视频', '关闭音视频', true),
  ]
  // 屏幕设备开关。 屏幕设备默认是关闭状态，页面初始化时，屏幕流默认是不推送的。
  defaultLocalScreen = new ToolButtonClass(1, "屏幕分享", 'screen-control-open.svg', 'screen-control-close.svg', '开启屏幕分享', '关闭屏幕分享', true)
  materials = []
  isSend = true
  height = 300
  teacherId = ''
  teacherRtcUserId = '' // 教师在rtc直播间内的用户ID
  // 教师视频预览是否展示，
  teacherVideoShow = false
  // 教师视频不展示时的缺省文案
  teacherVideoDefaultText = '教师未推送视频流'
  // 是否显示本地预览的video标签
  showLocalPreviewVideo = false
  // 隐藏本地预览video标签的原因文案
  hideLocalPreviewVideoReason = '音视频已关闭'
  classActivityStatusTopic = {
    topic: `${class_activity_status_topic_prefix}{classId}`,
    qos: 2,
    pattern: `^${class_activity_status_topic_prefix}{classId}$`
  }
  freeActivityStatusTopic = {
    topic: `${free_activity_status_topic_prefix}{classIdCode}`,
    qos: 2,
    pattern: `^${free_activity_status_topic_prefix}{classIdCode}$`
  }
  otherActivityCommonTopicList = [
    {
      topic: `${class_activity_chat_message_topic_prefix}{activityId}`,
      qos: 1,
      pattern: `^${class_activity_chat_message_topic_prefix}{activityId}$`,
      canSubscribe: false
    },
    {
      topic: `${class_activity_announcement_topic_prefix}{activityId}`,
      qos: 1,
      pattern: `^${class_activity_announcement_topic_prefix}{activityId}$`,
      canSubscribe: false
    },
    {
      topic: `${class_activity_forced_kick_topic_prefix}{classId}`,
      qos: 2,
      pattern: `^${class_activity_forced_kick_topic_prefix}{classId}$`,
      canSubscribe: false
    },
    {
      topic: `${teacher_online_status_topic_prefix}{teacherId}`,
      qos: 2,
      pattern: `^${teacher_online_status_topic_prefix}{teacherId}$`,
      canSubscribe: false
    },
  ]
  activityMessageBase: MessageBase = null
  // 其他在线人数
  otherOnlineUserCount = 0

  @Ref() readonly message
  @Ref("onlineUserList") readonly onlineUserList

  /**
   * 组件内部路由守卫，在路由跳转离开本页面之前触发。
   *
   * 使用页面销毁前的钩子函数 beforeDestroy 执行本逻辑，无法保证异步执行的推出马良笔双师课堂执行完后再跳转页面。
   * 而 window.onbeforeunload 事件监听在路由跳转时又无法触发。
   * 所以需要使用组件内部的路由守卫，来配合window.onbeforeunload，对本页面的跳转、刷新、关闭等事件做到全方位的监听。
   */
  beforeRouteLeave(to, from, next) {
    console.log('before route leave hook trick !')
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.leaveCurrentPage().then(() => {
      next()
    }).catch(err => {
      RTCClient.instance.dispose()
      console.error(err)
      next()
    })
  }

  /**
   * 离开本页面触发的事件回调
   *
   */
  leaveCurrentPage() {
    return new Promise((resolve, reject) => {
      this.loading = true
      // 关闭页面内未关闭的弹框，比如参数不合法弹框。
      try {
        MessageBox.close()
      }catch (err) {
        console.log('close message box error. perhaps current page dose not have message box.')
        console.error(err)
      }
      // 取消订阅主题
      this.doUnSubscribe()
      setTimeout(() => {
        // 销毁mqtt实例
        MqttClient.instance.end().then(() => {
          // 注销RTC实例的回调
          RTCClient.instance.unRegisterCallBack()
          // 退出直播间
          RTCClient.instance.logout().then((res) => {
            // 销毁实例
            RTCClient.instance.dispose()
            resolve(res)
          }).catch(err => {
            console.error(err)
            RTCClient.instance.dispose()
            reject(err)
          })
        })
      }, 300)
    })
  }
  created(): void {
    this.gardenId = this.local$.getItem('gardenId')
    window.addEventListener('keydown', this.stopF5Refresh)
    let params = this.$route.params;
    console.log(params)
    if (params && params.rtc_auth_info) {
      this.rtcAuthInfo = params.rtc_auth_info
      this.displayName = params.display_name
      this.userId = params.user_id
      this.userType = params.user_type
    }
  }

  /**
   *页面初始化
   */
  mounted(): void {
    window.addEventListener('beforeunload', this.beforeunloadHandler)
    let params = this.$route.params;
    console.log(params)
    if (this.rtcAuthInfo) {
      this.init(params);
      this.videoLeft();
    }  else {
      let confirmTitle = '当前页面参数不合法，您的访问地址可能非法请关闭本页面重新从合法路径访问本页面！'

      this.$elementConfirm(confirmTitle, "提示", {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        closeOnPressEscape: false,
        closeOnHashChange: true
        // type: 'warning'
      }).then(() => {
      })
    }
  }

  /**
   * 阻止页面刷新
   * <p>
   *   目前可以阻止F5刷新，crtl+R刷新，ctrl+F5刷新。
   *   无法阻止点击浏览器刷新按钮刷新，无法阻止用户点击其他按钮后再使用ctrl+R刷新（比如：用户点击的是ctrl+E+R仍然能刷新，用户点击了
   *   ctrl+E再点击ctrl+R也能刷新）
   * </p>
   */
  stopF5Refresh(e) {
    var evt = window.event || e
    var code = evt.keyCode || evt.which
    console.log(e.ctrlKey,  code)
    // 屏蔽F5 和 crtl + R
    if (code == 116 || (e.ctrlKey == true && code == 82)  || (e.ctrlKey == true && code == 116)) {
      if (evt.preventDefault) {
        evt.preventDefault()
      } else {
        evt.keyCode = 0
        evt.returnValue = false
      }
    }
  }

  /**
   * window.onbeforeunload 回调事件。 在页面关闭或者页面刷新时触发。
   *
   * 内部执行马良笔双师课堂退出逻辑，在退出成功后结束本页面。 若退出失败，会弹出提示信息。
   */
  beforeunloadHandler(event) {
    console.log('before unload handle trick')
    this.leaveCurrentPage().then((res) => {
      console.log(res)
    }).catch(err => {
      console.error(err)
    })
  }

  /**
   *页面销毁之前
   */
  destroyed(): void {
    console.log("destroyed hook trick.....");
    window.removeEventListener('beforeunload', this.beforeunloadHandler)
    window.removeEventListener('keydown', this.stopF5Refresh)
  }

  /**
   * 跳转到远程访问地址
   *
   * 从本项目跳转到导航菜单内的其他项目时调用。
   * 如点击首页或mqtt连接失败且选择退出马良笔双师课堂时使用
   */
  toRemoteRouter(tab = null) {
    console.log(tab);
    let gardenId = window.localStorage.getItem("gardenId")
    let qToken = window.localStorage.getItem("LWToken")
    window.location.href =
      this.filePre$.studentAirCLassRoomUrl +
      `?gardenId=${gardenId}&token=${qToken}`;
  }

  /**
   * 处理路由跳转携带参数
   *
   * 本页面有两个入口：
   *  1、登录用户通过班级正在进行的马良笔双师课堂活动点击进入，路由参数中会携带
   *  用户的身份信息和活动的基础信息。
   *  2、登录用户和非登录用户，通过课堂Id码进入。入参有课堂ID码和用户的身份信息，
   *  没有活动的基本信息
   */
  init(params) {
    // 如果入参带有课堂Id码，证明是通过课堂ID码手动加入马良笔双师课堂的
    if (params.class_id_code && params.class_id_code !== '') {
      this.joinType = 'freeJoin'
      this.classIdCode = params.class_id_code
      // 链接mqtt客户端，去订阅马良笔双师课堂活动topic，等到收到活动开始消息后，再进入直播间，订阅教师流
      this.connectMqtt()
    } else {
      this.joinType = 'class'
      this.initClassActivity(params)
      this.rtc()
      this.connectMqtt()
    }
  }

  /**
   * 初始化班级活动
   *
   */
  initClassActivity(activityInfo) {
    // 否则是通过班级正在进行的马良笔双师课堂活动进行的，开始初始化信息
    this.initActivityMessageBase(activityInfo)
    this.classIdCode = activityInfo.channel_id
    this.leftHeadInfo = this.activityMessageBase.activity_name
    if (this.activityMessageBase.activity_teacher_id
        && this.activityMessageBase.activity_teacher_id.startsWith(UserType.notLoggedIn)) {
      this.teacherId = this.activityMessageBase.activity_teacher_id
    } else {
      this.teacherId = `${RTCUserMark.teacher}${this.activityMessageBase.activity_teacher_id}_`
    }

  }

  /**
   * 初始化活动基本信息
   */
  initActivityMessageBase(activityInfo) {
    this.activityMessageBase = new MessageBase(
      activityInfo.activity_id,
      activityInfo.activity_name,
      activityInfo.activity_type,
      activityInfo.instruction_order,
      activityInfo.prepare_status,
      activityInfo.garden_id,
      activityInfo.garden_name,
      activityInfo.grade_id,
      activityInfo.grade_name,
      activityInfo.class_id,
      activityInfo.class_name,
      activityInfo.class_section,
      activityInfo.subject_code,
      activityInfo.subject_name,
      activityInfo.activity_teacher_name,
      activityInfo.activity_teacher_id.toString(),
      activityInfo.year,
      activityInfo.lesson_id,
      activityInfo.date,
      activityInfo.week
    )
  }

  /**
   * 连接MQTT服务器
   *
   */
  connectMqtt() {
    MqttClient.instance.end().then(() => {
      const clientId = `${this.filePre$.mqttClientId}S_${this.userId}`
      MqttClient.instance.setClientId(clientId)
      MqttClient.instance.connect()
      //注册mqtt 回调事件
      this.registerCallBackMqtt()
    })

  }

  /**
   * 注册mqtt 回调事件
   */
  registerCallBackMqtt() {
    MqttClient.instance.registerCallBack((eventName, data) => {
      switch (eventName) {
        case "connect":
          this.loading = false
          if (this.joinType === 'class') {
            this.subscribeClassActivityTopic()
            this.subscribeCommonTopic()
          } else {
            this.subscribeFreeActivityTopic()
          }
          break
        case "message":
          this.processMessage(data)
          break
        case "close":
          this.mqttClose(data)
      }
    });
  }

  /**
   * mqtt客户端连接关闭回调函数
   *
   * 无论是因为异常原因断开还是主动断开，都会走此回调。
   * 主动退出时，不做任何处理。
   * 如果不是主动退出，不论任何原因，提示用户已经断开，询问用户是否重连。
   *
   * @param initiativeQuit 是否是主动退出。主动退出为true，否则为false
   *
   */
  mqttClose(initiativeQuit) {
    if (initiativeQuit) {
      return
    }
    let _that = this
    const confirmHtml = `您当前和服务端的消息服务器断开连接！造成断开连接的原因可能包括以下两种：<br/>
1.您的账号在其他地方登录并使用了连接消息服务器服务造成将您当前的连接断开；<br/>
2.由于网络连接不通导致您和消息服务器断开。`
    this.$alert(confirmHtml, "断开连接提示", {
      confirmButtonText: "尝试重新连接",
      cancelButtonText: '退出双师课堂 ',
      dangerouslyUseHTMLString: true,
      showCancelButton: true,
      closeOnClickModal: false,
      showClose: false,
    }).then(() => {
      MqttClient.instance.reconnect()
    }).catch((e) => {
      console.log(e)
      _that.toRemoteRouter()
    })
  }


  /**
   * 订阅班级活动状态主题
   */
  subscribeClassActivityTopic() {
    if (!this.activityMessageBase) {
      return
    }
    this.classActivityStatusTopic.topic = this.classActivityStatusTopic.topic
      .replace('{classId}', this.activityMessageBase.class_id.toString())
    this.classActivityStatusTopic.pattern = this.classActivityStatusTopic.pattern
      .replace('{classId}', this.activityMessageBase.class_id.toString())
    MqttClient.instance.doSubscribe(
      {topic: this.classActivityStatusTopic.topic, qos: this.classActivityStatusTopic.qos})
  }

  /**
   * 订阅自由发起的活动状态主题
   */
  subscribeFreeActivityTopic() {
    if (!this.classIdCode) {
      return
    }
    this.freeActivityStatusTopic.topic = this.freeActivityStatusTopic.topic
      .replace('{classIdCode}', this.classIdCode.toString())
    this.freeActivityStatusTopic.pattern = this.freeActivityStatusTopic.pattern
      .replace('{classIdCode}', this.classIdCode.toString())
    MqttClient.instance.doSubscribe(
      {topic: this.freeActivityStatusTopic.topic, qos: this.freeActivityStatusTopic.qos})
  }

  /**
   * 订阅马良笔双师课堂活动共有主题
   * 先替换马良笔双师课堂活动共有主题内的占位符，再去订阅替换占位符后真正需要订阅的主题
   */
  subscribeCommonTopic() {
    if (this.otherActivityCommonTopicList.length <= 0 || !this.activityMessageBase) {
      return
    }
    this.otherActivityCommonTopicList.forEach((x) => {
      if (-1 !== x.topic.indexOf("{classId}") && this.activityMessageBase.class_id) {
        x.topic = x.topic.replace(
          "{classId}",
          this.activityMessageBase.class_id.toString()
        );
        x.pattern = x.pattern.replace(
          "{classId}",
          this.activityMessageBase.class_id.toString()
        );
        x.canSubscribe = true
      }

      if (-1 !== x.topic.indexOf("{activityId}") && this.activityMessageBase.activity_id) {
        x.topic = x.topic.replace(
          "{activityId}",
          this.activityMessageBase.activity_id
        );
        x.pattern = x.pattern.replace(
          "{activityId}",
          this.activityMessageBase.activity_id
        );
        x.canSubscribe = true
      }
      if (-1 !== x.topic.indexOf('{teacherId}') && this.activityMessageBase.activity_teacher_id) {
        x.topic = x.topic.replace(
          '{teacherId}',
          this.activityMessageBase.activity_teacher_id.toString()
        )
        x.pattern = x.pattern.replace(
          '{teacherId}',
          this.activityMessageBase.activity_teacher_id.toString()
        )
        x.canSubscribe = true
      }
    })
    this.otherActivityCommonTopicList.forEach((x, index) => {
      if (!x.canSubscribe) {
        return
      }
      MqttClient.instance.doSubscribe({topic: x.topic, qos: x.qos});
    })
  }

  /**
   * 取消订阅主题
   * <p>
   *  取消订阅班级活动状态、聊天主题、公告主题、互踢消息主题
   * </p>
   */
  doUnSubscribe() {
    if (this.joinType === 'class') {
      MqttClient.instance.doUnSubscribe({topic: this.classActivityStatusTopic.topic})
    } else {
      MqttClient.instance.doUnSubscribe({topic: this.freeActivityStatusTopic.topic})
    }
    this.otherActivityCommonTopicList.forEach((x, index) => {
      MqttClient.instance.doUnSubscribe({topic: x.topic})
    })
  }

  /**
   * mqtt 处理消息
   */
  processMessage(data) {
    // console.log(`data: ${data.topic},=>${data.message}`);
    const classActivityTopicPattern = new RegExp(this.classActivityStatusTopic.pattern, "g")
    const freeActivityTopicPattern = new RegExp(this.freeActivityStatusTopic.pattern, "g")
    const chatMessageTopicPattern = new RegExp(this.otherActivityCommonTopicList[0].pattern, "g")
    const announcementTopicPattern = new RegExp(this.otherActivityCommonTopicList[1].pattern, "g")
    const forcedKickTopicPattern = new RegExp(this.otherActivityCommonTopicList[2].pattern, "g")
    const teacherOnlineStatusPattern = new RegExp(this.otherActivityCommonTopicList[3].pattern, "g")

    // 收到当前班级的活动状态消息
    if (classActivityTopicPattern.test(data.topic)) {
      let msg = data.message as MessageBase
      // 如果是下课消息，直接下课。（上课消息，在进入直播间之前或者根据互踢进入新的活动之前就已经收到了，所以不需要再响应本活动的上课消息）
      if (msg.activity_type == "RTC_INTERACTIVE_CLASS"
        && msg.activity_id == this.activityMessageBase.activity_id
        && msg.activity_instruction == 'END_ACTIVITY'
      ) {
        // 下课
        this.outClass()
      }
      return
    }
    // 收到以本马良笔双师课堂的channel_id结尾的topic发来的消息
    if (freeActivityTopicPattern.test(data.topic)) {
      console.log('received free activity topic message, message : ', data.message)
      let msg = data.message as MessageBase
      if (msg.activity_type !== "RTC_INTERACTIVE_CLASS") {
        return
      }
      msg.activity_teacher_id = data.message.teacher_id
      msg.activity_teacher_name = data.message.teacher_name
      // 如果是上课消息
      if (msg.activity_instruction == 'START_ACTIVITY') {
        // 初始化班级活动信息
        this.initClassActivity(msg)
        // 需要订阅本次活动的状态topic，收到topic对应的活动开始的指令后，再初始化信息并且开始活动
        // 订阅班级活动共有topic
        this.subscribeCommonTopic()
        // 初始化自身的rtc实例
        this.rtc()
      } else {
        this.outClass()
      }
      return
    }
    // 收到当前班级的活动互踢消息
    if (forcedKickTopicPattern.test(data.topic)) {
      this.forcedKickF(data.topic, data.message)
      return
    }
    // 收到当前活动发起教师的上下线消息
    if (teacherOnlineStatusPattern.test(data.topic)) {
      // 如果收到当前活动的教师下线消息，则退出当前活动
      this.teacherOnlineStatusChange(data.topic, data.message)
      return
    }
    // 收到当前活动的聊天或者是公告消息
    if (chatMessageTopicPattern.test(data.topic) || announcementTopicPattern.test(data.topic)) {
      this.message.processMessage(data)
      return
    }
  }

  /**
   * 当前活动的发起教师状态更改消息处理函数
   *
   * <p>
   *  如果当前发起活动的教师下线了，直接退出当前直播间。
   *  收到教师下线消息后，等到1S中再执行退出直播间的逻辑，退出直播间前先判断当前用户是否已经在其他位置退出直播间了。
   *  这几个判断逻辑，是为了避免教师下线消息和活动结束消息同时收到之后，同时执行退出直播间的逻辑导致异常。
   * </p>
   */
  teacherOnlineStatusChange(topic, message) {
    if (UserOnlineStatus.offline === message.online_status
      && this.activityMessageBase.activity_teacher_id == message.id) {
      setTimeout(() => {
        if (this.inClassroom) {
          this.$message.info('当前课堂教师已下线！')
          this.logoutClassRoom()
        }

      }, 1000);

    }
  }

  /**
   * 强制踢掉
   *    活动id一致，并且 要踢掉的活动创建时间要在当前活动创建时间之后
   * @param topic
   * @param message
   */
  forcedKickF(topic, message) {
    // 如果被强提的活动Id与当前学生正在参加的教学活动一致，且新活动的创建时间在当前进入直播间的时间之后，且活动类型也一致，则执行强踢下线消息
    if (
      message.kicked_activity &&
      message.kicked_activity.activity_id == this.activityMessageBase.activity_id &&
      message.kicked_activity.activity_type == this.activityMessageBase.activity_type
    ) {
      let activityTypeName = util.convertActivityTypeToName(
        message.new_activity.activity_type
      );
      // 拼接活动被强踢下线的消息提示内容
      let confirmHtml = `
          <p class="el-message-box_content-title">
            <span class="el-message-box__highLight">${this.displayName}</span>同学您好：
          </p>
          <p class="el-message-box_indentTag">
            当前您正在进行的教学活动已被<span class="el-message-box__highLight">${message.new_activity.teacher_name}</span>老师最新发起的<span class="el-message-box__highLight">${message.new_activity.activity_name}（${activityTypeName}）</span>教学活动切换。
          `;
      let confirmButtonBaseText;
      if ("RTC_INTERACTIVE_CLASS" === message.new_activity.activity_type) {
        confirmHtml += `
          3秒后将自动切换到该<span class="el-message-box__highLight">${activityTypeName}</span>教学活动。
          </p>
        `;
        confirmButtonBaseText = "切换";
      } else {
        confirmHtml += `
         该<span class="el-message-box__highLight">${activityTypeName}</span>在当前终端不背支持。若要参加该类教学活动请切换到支持的终端登录。3秒后页面将自动返回。
          </p>
        `;
        confirmButtonBaseText = "返回";
      }
      var confirmButtonText = `${confirmButtonBaseText}(3秒)`
      // 使用element-ui的messagebox弹出提示消息
      this.$alert(confirmHtml, "教学活动切换通知", {
        confirmButtonText: confirmButtonText,
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        showClose: false,
      }).then(() => {
        window.clearInterval(interval);
        window.clearTimeout(timeout);
        // 如果是新的马良笔双师课堂活动，直接进入马良笔双师课堂
        if ("RTC_INTERACTIVE_CLASS" === message.new_activity.activity_type) {
          // 退出RTC直播间
          RTCClient.instance.logout().then(res => {
            // 取消订阅活动状态、聊天、公告、互踢活动等消息主题
            that.doUnSubscribe()
            // 进入新的马良笔双师课堂活动
            that.initClassActivity(message.new_activity)
            this.rtc()
            if (this.joinType === 'class') {
              this.subscribeClassActivityTopic()
            } else {
              this.subscribeFreeActivityTopic()
            }
            this.subscribeCommonTopic()
          }).catch(err => {
            this.$message('进入新的马良笔双师课堂活动失败，请退出当前马良笔双师课堂后再进入新的马良笔双师课堂活动！')
          })

        } else {
          // 如果不是马良笔双师课堂，则返回学生课表页面
          that.logoutClassRoom()
        }
      });

      var countdown = 3;
      // 3秒倒计时后自动触发消息弹框的点击事件
      const timeout = setTimeout(() => {
        window.clearInterval(interval);
        let confirmButton = document.querySelector(
          '.el-message-box__btns button span'
        ) as HTMLElement
        confirmButton.click()
      }, countdown * 1000);

      let that = this;
      // 倒计时修改弹框中确认按钮的文本之前，需要先重置按钮的文本为初始文本。 避免页面内多次弹框之后
      that.changeConfirmButtonContent(confirmButtonText)
      // 倒计时去修改消息提示弹框中按钮的文本
      var interval = setInterval(() => {
        countdown--;
        confirmButtonText = `${confirmButtonBaseText}(${countdown}秒)`
        that.changeConfirmButtonContent(confirmButtonText)
        // 倒计时结束清除倒计时的对象
        if (countdown === 0) {
          window.clearInterval(interval);
          window.clearTimeout(timeout);
        }
      }, 1000);


    }
  }

  changeConfirmButtonContent(content = "") {
    let confirmButtonSpan = document.querySelector(
      ".el-message-box__btns button span"
    )
    confirmButtonSpan.innerHTML = content;
  }

  /***
   * 老师下课
   */
  outClass() {
    //    加入下课,退出系统跳转到 学生端
    setTimeout(() => {
      if (this.inClassroom) {
        this.$message('当前马良笔双师课堂活动已结束！')
        this.logoutClassRoom()
      }
    }, 200)
  }

  /**
   * webrtc 初始化
   */
  rtc() {
    if (this.rtcAuthInfo) {
      // 注册回调
      this.registerCallBack()
      //学生加入课堂
      RTCClient.instance
        .joinChannel(
          this.rtcAuthInfo,
          this.displayName
        )
        .then((res) => {
          //开始推送学生的摄像头画面。 因为在进入直播间之间就已经校验了学生客户端是否支持rtc，所以此处不做冗余校验
          this.videoSourceButtonClickHandler(1)
        })
        .catch(err => {
          if (err && err.errorCode == 10500) {
            this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
          } else {
            this.$message('系统异常，请稍后重试！')
          }
        });
    }
  }

  /**
   * 屏幕分享异常
   * <p>
   *   如果是碰到状态码10010（未知错误）或者10013（系统禁止屏幕分享），给出吐司提示。
   *   如果状态码是10012（手动结束屏幕分享）或者10011（分享时取消分享），不给吐司提示。
   *   同时更改屏幕控制按钮的状态
   * </p>
   */
  onErrorScreenSharePreview(error) {
    switch (error.errorCode) {
      case 10010:
        this.$message('屏幕共享出现未知错误，将自动切换到本机摄像头进行共享')
        break
      case 10013:
        this.$message('当前系统禁止屏幕共享，将自动切换到本机摄像头进行共享')
        break
      default:
        break
    }
    this.defaultLocalScreen.setActive(true)
  }

  /**
   * 远端推流回调处理函数
   *
   * @param {*} teacher 发起马良笔双师课堂活动的教师在RTC直播间的ID
   * @param {*} publisherData 远端发起推流的RTC用户信息和流信息
   */
  listenerRemotePublisherHandler(publisherData) {
    console.log('this teacherId is :', this.teacherId)
    console.log(publisherData)
    // 如果当前流状态信息改变的，是以当前教师的固定前缀开头的，证明是当前课堂的发起教师的流信息发生更改
    if (this.teacherId && publisherData.userId.startsWith(this.teacherId)) {
      // 找到当前处于活跃状态的流信息
      let streamConfigs = publisherData.streamConfigs.filter(item => item.state === 'active')
      this.setSubscribeRemoteStream(publisherData.userId, streamConfigs)
    } else {
      // 否则执行其他用户的视频流订阅任务
      this.onlineUserList.userPublishChange(publisherData)
    }
  }


  /**
   * 设置具体订阅的流的信息
   *
   * @param {*} publisherId
   * @param {*} streamConfigs
   */
  setSubscribeRemoteStream(publisherId, streamConfigs = null) {
    this.teacherRtcUserId = publisherId
    // 订阅具体的流数据
    RTCClient.instance
      .setSubscribeStream(publisherId, streamConfigs)
      .then((result) => {
        // 视频画面数更新
        this.pictureCount = result.pictureCount
        if (result.pictureCount === 0) {
          this.teacherVideoShow = false
          this.teacherVideoDefaultText = '教师停止推送视频流'
        } else {
          // 定义主画面和浮动画面ID变量
          const mainPictureVideoId = this.teacherId + '-main-picture'
          const floatingPictureVideoId = this.teacherId + '-floating-picture'

          // 展示视频画面标志位更改
          this.teacherVideoShow = true
          if (result.pictureCount > 1) {
            this.displayRemoteVideo(publisherId, mainPictureVideoId, 2)
            this.displayRemoteVideo(publisherId, floatingPictureVideoId, 1)
          } else {
            if (result.mainPictureType === 2) {
              this.displayRemoteVideo(publisherId, mainPictureVideoId, 2)
            } else {
              this.displayRemoteVideo(publisherId, mainPictureVideoId, 1)
            }
          }
        }
      }).catch((reject) => {
      this.teacherVideoShow = false
      this.pictureCount = 0
      // 如果存在订阅失败异常信息，吐司提示为何订阅失败，并且教师视频预览区域展示缺省文案
      if (reject.result.pictureCount === 0) {
        // 如果没有订阅失败异常信息，但是进入了错误回调，那么代表当前没有活跃的视频流，教师视频预览区域展示缺省文案
        this.teacherVideoDefaultText = '教师停止推送视频流'
      } else {
        if (reject.error.errorCode === 10500) {
          this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
        } else {
          this.$message('订阅发起教师分享的视频时出现异常！')
        }
        this.teacherVideoDefaultText = '订阅用户分享视频异常'
      }
    })
  }

  /**
   * 展示远端视频
   * @param publisherId 推流用户ID
   * @param videoEleId  视频标签ID
   * @param videoStreamType 流类型。 1：摄像头流，2：屏幕分享流
   */
  displayRemoteVideo(publisherId, videoEleId, videoStreamType) {
    // 下次 DOM 更新循环结束之后执行延迟回调。当前即video标签渲染成功后再执行后续步骤
    this.$nextTick(() => {
      // 找到video标签
      let videoEle = document.getElementById(videoEleId) as HTMLVideoElement
      // let videoEle = document.getElementById('teacherVideo') as HTMLVideoElement
      RTCClient.instance.setDisplayRemoteVideo(
        publisherId,
        videoEle,
        videoStreamType
      )
    })
  }

  /**
   * 远端用户上线事件
   */
  rtcUserOnlineHandle(onlineUser) {
    const currentUserId = this.rtcAuthInfo.userid
    // 如果上线的用户是当前用户或者是当前课堂活动的发起教师用户，不做后续处理
    // 如果当前直播间的发起教师信息不存在，那么先不要处理远端用户上线。（避免将发起教师的画面展示到其他在线人员列表中）
    // 如果当前上线用户为教师或者是自身，那么也不用处理远端用户上线
    if (!this.teacherId || onlineUser.userId.startsWith(this.teacherId) ||
      onlineUser.userId === currentUserId) {
      return
    }
    // 执行用户列表中的用户上线事件
    this.otherOnlineUserCount++
    this.onlineUserList.userOnline(onlineUser)
  }


  /**
   * 设置教师播放器静音与否
   */
  setTeacherPlayerMuted(playerObj) {
    const muted = playerObj.muted
    RTCClient.instance.muteRemoteAudioPlaying(this.teacherRtcUserId, muted)
  }

  /**
   * 设置教师的播放器的订阅音量
   */
  setTeacherPlayerVolume(playerObj) {
    const volume = playerObj.volume
    RTCClient.instance.setAudioVolume(this.teacherRtcUserId, volume)
  }

  /**
   * 远端用户下线事件
   */
  rtcUserOfflineHandle(offlineUser) {
    const currentUserId = this.rtcAuthInfo.userid
    // 如果下线的用户是当前用户或者是当前课堂活动的发起教师用户，不做后续处理
    if (!this.teacherId || offlineUser.userId.startsWith(this.teacherId) ||
      offlineUser.userId === currentUserId) {
      return
    }
    this.otherOnlineUserCount--
    this.onlineUserList.userOffline(offlineUser)
  }

  // 注册回调
  registerCallBack() {
    RTCClient.instance.registerCallBack((eventName, data) => {
      switch (eventName) {
        case "onReSubscribe":
          //取消订阅,重新订阅
          RTCClient.instance.unRegisterCallBack();
          this.registerCallBack();
          break;
        case "onErrorScreenSharePreview":
          //屏幕分享错误
          this.onErrorScreenSharePreview(data);
          break;
        case "onPublisher":
          // 收到远端推流的回调函数 （不论老师和学生开始推流，都回收到远端推流通知，进入此回调）
          this.listenerRemotePublisherHandler(data);
          break
        case 'onJoin':
          // 收到用户上线通知
          this.rtcUserOnlineHandle(data)
          break
        case 'onLeave':
          // 收到用户下线通知
          this.rtcUserOfflineHandle(data)
          break
      }
    });
  }

  /**
   * 动态计算我的输出画面video高度
   */
  videoLeft() {
    function cw(_this) {
      let videoC = _this.$refs.videoLeft;
      const height = (videoC.offsetWidth - 2) * (9 / 16) + 30;
      videoC.style.minHeight = Math.floor(height) + "px";
      _this.height = Math.floor(height - 30 - 122);
      let myVideo = document.getElementById("myVideo");
      const myHeight = (myVideo.offsetWidth - 2) * (9 / 16);
      myVideo.style.height = Math.floor(myHeight) + "px";
    }

    let _this = this
    this.$nextTick(() => {
      cw(_this)
    })
    window.onresize = () => {
      return (() => {
        cw(_this);
      })();
    };
  }

  /**
   * 视频源切换点击处理函数
   *
   *  @param {*} val  直播信号源按钮的key值。 1、本机摄像头；2：电脑屏幕；
   */
  videoSourceButtonClickHandler(val) {
    // 根据val，查找工具数据中当前的列时否是选中状态，
    const index = this.videoSourceOptionList.findIndex(item => item.key === val)
    let currentToolActive = false
    if (index > -1) {
      currentToolActive = this.videoSourceOptionList[index].getActive()
    }
    // 如果当前的工具按钮已经处于选中状态，则点击无任何相应
    if (currentToolActive) {
      return
    }
    this.videoSourceOptionList.forEach((e) => {
      if (e.key === val) {
        e.setActive(true);
      } else {
        e.setActive(false);
      }
    });

    switch (val) {
      case 1:
        // 本机摄像头
        // this.switchToLocalCameraHandler()
        // 学生进入直播间，默认摄像头、麦克风、屏幕都不推流
        RTCClient.instance.setLocalAudioPublishStatus(false)
        RTCClient.instance.setLocalCameraPublishStatus(false)
        RTCClient.instance.setScreenPublishStatus(false)

        break
    }
  }

  /**
   * 本机摄像头
   */
  switchToLocalCameraHandler() {
    // this.localMicroControl(1, false)
    this.localCameraControl(2, false)
  }

  /**
   * 本机摄像头预览控制
   *
   * <p>
   * 如果当前传入的参数是允许预览，那么就开启预览；否则关闭预览，展示缺省文案
   * </p>
   *
   * @param {boolean} previewStatus 预览状态。 true：可以预览，false：不能预览
   */
  localCameraPreviewControl(previewStatus = true) {
    // 如果当前禁止采集本地摄像头
    if (!previewStatus) {
      RTCClient.instance.stopPreview().then(res => {
        console.log('本机摄像头画面预览结束，开始展示缺省内容')
        // 画面展示区域的标志位更改
        this.showLocalPreviewVideo = false
        // 缺省的文案赋值
        this.hideLocalPreviewVideoReason = '音视频已关闭'
      }).catch(err => {
        console.error(err)
        this.$message('停止本机摄像头画面预览失败，请重试！')
      })
    } else {
      // 如果当前允许采集本机摄像头，且当前正在预览本机摄像头画面当中，开启预览，展示预览画面
      this.showLocalPreviewVideo = true
      this.hideLocalPreviewVideoReason = ''
      this.$nextTick(() => {
        let studentVideo = document.getElementById("studentVideo");
        RTCClient.instance.startPreview(studentVideo).then(res => {
          console.log('开始本机摄像头预览，展示预览画面')
        }).catch(err => {
          console.error(err)
        })
      })
    }
  }

  /**
   * 本地设备控制按钮点击处理函数
   * @param {number} key 设备的key值。 1：麦克风设备，2：摄像头，3：画质控制（未启用）
   * @param {boolean} activeStatus 当前按钮的活跃状态
   */
  localDeviceControlClickHandler(key: number, activeStatus: boolean) {
    switch (key) {
      case 1:
        //麦克风
        this.localMicroControl(key, activeStatus)
        break;
      case 2:
        // 摄像头控制
        this.localCameraControl(key, activeStatus)
        break;
      case 3:
        // 画质控制
        break;
    }
  }

  /**
   * 本地麦克风控制
   * <p>
   *   控制是否推送本机音频流
   *   按钮当前状态如果是活跃状态，那么代表按钮点击之前的状态是非活跃状态（可以理解为点击的是红色图标）
   *   那么此时，对应的操作应该是关闭音频流的推送； 否则，开启音频的推送。
   * </p>
   */
  localMicroControl(key: number, activeStatus: boolean) {
    // 设置音频流的推送状态 (按钮状态为true，禁止推送音频流；否则允许推送音频流)
    RTCClient.instance.setLocalAudioPublishStatus(!activeStatus)
    // 设置完成后，重新推拉流
    RTCClient.instance.publish().then(res => {
      if (!activeStatus) {
        this.$message.success('麦克风已开启')
      } else {
        this.$message.success('麦克风已关闭')
      }
    }, reject => {
      console.log(reject)
    }).catch(err => {
      console.error(err)
      if (err && err.errorCode == 10500) {
        this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
      } else {
        this.$message('系统异常，请稍后重试！')
      }
    })
  }

  /**
   * 本机摄像头流控制
   *
   * <p>
   *   开启或者关闭本机摄像头视频流的推送以及本机视频预览
   *  按钮当前状态如果是活跃状态，那么代表按钮点击之前的状态是非活跃状态（可以理解为点击的是红色图标）
   *  那么此时，对应的操作应该是关闭本机摄像头流的推送和关闭预览； 否则，开启本机摄像头流的推送和开启预览。
   * </p>
   */
  localCameraControl(key: number, activeStatus: boolean) {
    // 设置音频流的推送状态 (按钮状态为true，禁止推送音频流；否则允许推送音频流)
    RTCClient.instance.setLocalAudioPublishStatus(!activeStatus)
    // 设置是否允许推流
    RTCClient.instance.setLocalCameraPublishStatus(!activeStatus)
    // 停止或者开始本地视频预览
    this.localCameraPreviewControl(!activeStatus)
    // 重新推流
    RTCClient.instance.publish().then(res => {
      if (!activeStatus) {
        this.$message.success('本机音视频分享中')
      }
    }).catch(err => {
      console.error(err)
      if (err && err.errorCode == 10500) {
        this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
      } else {
        this.$message('系统异常，请稍后重试！')
      }
    })
  }

  /**
   * 屏幕分享按钮控制点击事件处理函数
   *
   * <p>
   *   根据当前按钮的状态，去开始或者关闭屏幕分型流的推送.
   *   如果当前按钮是活跃状态，那么代表着按钮点击之前是非活跃状态（即点击的是红色的图标）。
   *   此时应该是禁止屏幕分享；否则应该是允许屏幕分享。
   *   可以理解为，是否允许屏幕分享，是和按钮最新的状态是相反的。
   * </p>
   */
  screenDeviceControlClickHandler(key: number, activeStatus: boolean) {
    console.log(activeStatus)
    if (!RTCClient.instance.isSupportScreenShare()) {
      let confirmTitle =
        '<div style="font-size: 16px;text-indent:2em;line-height: 30px">您当前使用的浏览器类型或版本不支持使用屏幕分享功能。请更换至以下浏览器类型或版本后再试：\n' +
        'Chrome浏览器72或以上版本，Edge浏览器80或以上版本。</div>';

      this.$elementConfirm(confirmTitle, "提示", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        closeOnClickModal: false,
        transition: "",
        // type: 'warning'
      }).then(() => {
      })
      // 重置屏幕分享按钮的状态
      this.defaultLocalScreen.setActive(true)
      return
    }
    RTCClient.instance.setScreenPublishStatus(!activeStatus)
    RTCClient.instance.publish().then(res => {
      // 如果按钮为未活跃状态，代表着开始分享屏幕流，给出吐司提示
      if (!activeStatus) {
        this.$message.success('本机屏幕共享中')
      } else {
        // 否则给出停止分享的吐司
        this.$message.success('本机屏幕共享结束')
      }
    }, reject => {
      console.log(reject)
    }).catch(err => {
      console.error(err)
      if (err && err.errorCode == 10500) {
        this.$message('您当前的操作频率太快，服务端将停止响应这些操作事件!')
      } else {
        this.$message('系统异常，请稍后重试！')
      }
    })

  }

  /**
   * 退出马良笔双师课堂
   *
   * 收到教师下线、教师结束马良笔双师课堂、互踢且新活动不是马良笔双师课堂活动时触发。
   * 回调到当前页面路由的上一个路由中。 学生是回到学生入口页面，教师回到课表页面，非登录用户回到自由加入页面
   */
  logoutClassRoom() {
    // 如果当前已经不在课堂中了，之前已经推出或者正在退出中时，不再重新执行退出逻辑。
    if (!this.inClassroom) {
      console.log('The current user has left the class')
      return
    }
    this.inClassroom = false
    let path = ''
    let breadList = this.$route.meta.breadList
    if (breadList && breadList.length > 2) {
      path = breadList[breadList.length - 2].path
    } else {
      path = breadList[0].path
    }
    this.$router.push({path: path})
  }

}
